import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import {Row, Col} from 'react-flexbox-grid'
import Styles from './DeforestationRiskSectorIconRow.css'


@CSSModules(Styles, {allowMultiple:true})
export default class DeforestationRiskSectorIconRow extends Component {
  render() {
    const poIcon = require( '../../../static/images/icn-po-w.svg' )
    const ppIcon = require( '../../../static/images/icn-pp-w.svg' )
    const rbIcon = require( '../../../static/images/icn-rb-w.svg' )
    const tbIcon = require( '../../../static/images/icn-tb-w.svg' )
    const bfIcon = require( '../../../static/images/icn-bf-w.svg' )
    const syIcon = require( '../../../static/images/icn-sy-w.svg' )
    //
    return <div styleName='sector-icons'>
        <Row>
          {
            [
              ['Palm oil', poIcon],
              ['Paper/pulp', ppIcon],
              ['Rubber', rbIcon],
              ['Timber', tbIcon],
              ['Cattle', bfIcon],
              ['Soy', syIcon],
            ].map((e, i) => {
              return <Col styleName='sector-icons__col' xs={4} sm={2}>
                {e[0]}
                <img
                  styleName='sector-icons__img'
                  alt={e[0]}
                  src={e[1]}
                />
              </Col>
            })
          }
        </Row>
    </div>
  }
}

